import { IEditor, PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function tableEditImportTrigger(event: PluginEvent, editor: IEditor) {
    return (
        event.eventType == PluginEventType.ContentChanged ||
        (event.eventType == PluginEventType.EditorReady && editor.queryElements('TABLE').length > 0)
    );
}
